<label>{{ 'FormulationSearch.Label.ColorNo' | translate }}<span *ngIf="showAsterisk"
        class="required-small">*</span></label>
<input InputMask [options]="options" [ngClass]="{'field-selected': isFilled}" name="color-number" [(ngModel)]="display"
    (blur)="onBlur()" (focus)="onFocus()" type="text" class="form-control">
